import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Controller, Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SearchFilters } from '../types/search.types';

interface ConditionFilterProps {
  readonly control: Control<SearchFilters>;
}

export function ConditionFilter({ control }: Readonly<ConditionFilterProps>) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="subtitle2"
        sx={{
          mb: 1,
          color: 'text.secondary',
          fontWeight: 500,
        }}
      >
        {t('search.condition.label')}
      </Typography>
      <Controller
        name="condition"
        control={control}
        render={({ field }) => (
          <ToggleButtonGroup
            {...field}
            exclusive
            fullWidth
            sx={{
              '& .MuiToggleButton-root': {
                py: 1,
                textTransform: 'none',
                fontWeight: 500,
                border: '1px solid',
                borderColor: 'divider',
                '&.Mui-selected': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                  },
                },
              },
            }}
          >
            <ToggleButton value="all">{t('search.condition.all')}</ToggleButton>
            <ToggleButton value="new">{t('search.condition.new')}</ToggleButton>
            <ToggleButton value="used">{t('search.condition.used')}</ToggleButton>
          </ToggleButtonGroup>
        )}
      />
    </Box>
  );
}
